"use client";

import { Icon } from "@iconify/react";
import { Link } from "@nextui-org/link";
import { button as buttonStyles } from "@nextui-org/theme";
import { Accordion, AccordionItem } from "@nextui-org/accordion";

import useToggleSelect from "@/src/hooks/useToggleSelect";
import { title, subtitle } from "@/components/primitives";
import { frequentlyQuestions } from "@/public/assets/data/landing-page";

export const FaqSection = () => {
  // Init toggle state handler
  const { handleToggle, toggle } = useToggleSelect();

  return (
    <div className="flex ct-hero ct-section w-full justify-center md:mx-auto">
      <div className="md:container xl:columns-2 px-8 lg:columns-2 gap-4 mt-[80px]">
        <div className="lg:w-full xl:w-4/5 md:w-full sm:w-full ct-description p-3 sm:p-2 break-after-column mb-8 w-full">
          <div data-aos="fade-up">
            <h3 className="my-2 text-start text-lg lg:text-xl text-default-600 font-semibold ct-text-primary">
              Common FAQs
            </h3>
            <h1 className={title({ fullWidth: false, size: "md" })}>
              Frequently Asked Questions
            </h1>
            <p className={subtitle({ class: "mt-7" })}>
              Here are the FAQs along with brief and easy-to-understand answers
              about what CryptoTX entails and how to use our services.
            </p>
            <div className="flex mt-8 break-after-column gap-6">
              <Link className={buttonStyles({
                  color: "primary",
                  radius: "md",
                  size: "lg",
                  variant: "shadow",
                })}
                href="/contact-us">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
        <div className="lg:w-full xl:w-full md:w-full sm:w-full ct-transfer px-5 flex flex-wrap items-center flex-col justify-center">
          <div data-aos="fade-right">
            <Accordion
              className="p-4 flex flex-col gap-6 w-full"
              isCompact={true}
              showDivider={true}
              variant="splitted">
              {frequentlyQuestions.map(({ id, qus, ans }, idx) => (
                <AccordionItem
                  key={id}
                  aria-label={qus}
                  indicator={
                    <Icon
                      className="ct-text-primary"
                      icon={
                        toggle === idx
                          ? "material-symbols:remove"
                          : "material-symbols:add"
                      }
                    />
                  }
                  title={qus}
                  onPress={() => handleToggle(idx)}
                >
                  {ans}
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};
